import layout from './FileUpload.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import FileUploadViewModelType from '@/ViewModels/Controls/FileUploadViewModel';
import EventHelper from '@/Utility/EventHelper';

export default class FileUpload extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: FileUploadViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyTemplate(layout, this.jQueryControl, () => {
            this.widget(null);
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'fileupload',

            locator: this.viewModel.locator,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            focus: this.viewModel.isFocusable,

            visible: this.viewModel.isVisible,

            invalid: "",

            styles: this.definePureComputed({
                read: () => {
                    var styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    var states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.linkSelect != null) {
            this.viewModel.linkSelect.onClick = () => {
                if (this.viewModel.fileFilter != null) {
                    this.jQueryControl.find('input[type=file]').attr('accept', this.viewModel.fileFilter);
                }

                this.jQueryControl.find('input[type=file]').trigger('click');
            };
        }

        if (this.viewModel.file != null) {
            this.addEventHandler('change', this.jQueryControl, (e: JQuery.ChangeEvent) => {
                let el = e.currentTarget as HTMLInputElement;
                if (el.value && el.files != null && el.files.length > 0) {
                    const fileFilter = this.viewModel.fileFilter
                    if (fileFilter)
                    {
                        //At this point we must check the file-extension, because the accept-filter doesn't disable 'selecting all files (*.*)'
                        let stopProcessing = false;
                        var extArray = el.value.match(/\.([^\.]+)$/); //hello.js.png -> one match ".png"
                        
                        if (Array.isArray(extArray)) {
                            var ext = extArray[extArray.length - 1];
                            const regex = new RegExp(`\\b${ext}\\b`, 'i');

                            if (!regex.test(fileFilter)) {
                                stopProcessing = true;
                            }
                        } else {
                            stopProcessing = true;
                        }

                        if (stopProcessing) {
                            el.value = '';
                            e.stopPropagation();
                            alert('Invalid file extension!');
                            return;
                        }
                    }
                    this.viewModel.setFile(el.files[0]);
                }
            }, '[type=file]');

            this.defineSubscription(this.viewModel.file, (file) => {
                if (file == null) {
                    (this.jQueryControl.find('form')[0] as HTMLFormElement).reset();
                }
            });
        }

        if (this.viewModel.isDropable) {
            const element = this.jQueryControl.find('input[type=text]').parent();
            EventHelper.bindDropAndAddEvent(element,
                this.viewModel.isEnabled,
                this.viewModel.checkDraggedElementsAllowed,
                null,
                null,
                this.viewModel.onDrop);
        }
    }

    public addLabelReference(label: JQuery): JQuery {
        let id = this.identifier + '-input';
        this.getControl().find('input').attr('id', id);
        label.attr('for', id);
        return label;
    }
}

ComponentManager.setControl('FileUpload', FileUpload, 'RADPresentation.HTMLClient.DefaultViewExtensions');